import React, { useContext } from "react";
import { useAuthContext } from "../../AuthContextWrapper";
import { GeographyType } from "../../models/Geography";
import { useNavigate } from "react-router-dom";
import EstateFormsComponent from "./EstateFormsComponent";
import { EstateFormsContext } from "EstateFormsContextWrapper";
import FormsLibrarySearch from "views/shared/forms/library/FormsLibrarySearch";
import ContactAnAdvisor from "./ContactAnAdvisorComponent";
import { QueryPayload } from "apis/FormsAPI";
import AtticusDrawer from "views/shared/drawer/AtticusDrawer";
import FormsFilesHeader from "./FormsFilesHeader";
import FeaturedFormCarousel from "views/shared/FeaturedFormCarousel";

const MAX_ESTATE_FORMS_TO_SHOW = 3;

const FormsAndFilesScreen = (): JSX.Element => {
  const navigate = useNavigate();

  const { activeEstate } = useAuthContext()
  const { estateForms } = useContext(EstateFormsContext);
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [drawerContents, setDrawerContents] = React.useState<JSX.Element>();
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  // Probate forms or forms library
  return activeEstate ? (
    <>
      <FormsFilesHeader title="My Forms" />
      <EstateFormsComponent
        truncateFormsAt={MAX_ESTATE_FORMS_TO_SHOW}
        openDrawer={handleDrawerOpen}
        setDrawerContents={setDrawerContents}
        onEmptyButtonClick={() => {
          navigate(`forms-library`, {
            state: {
              geography_type: GeographyType.State,
              geography_id: activeEstate.stateId,
            },
          });
        }}
        goToProbateDetermination={() => {
          navigate(`probate`);
        }}
        sx={{ mb: 5 }}
      />
      {estateForms && estateForms.length > 0 && (
        <FormsLibrarySearch
          onComplete={(values: QueryPayload) => {
            navigate(`forms-library`, {
              state: values,
            });
          }}
          loadingForms={false}
          initGeographyType={GeographyType.State}
          initGeographyId={activeEstate.stateId || undefined}
        />
      )}

      {activeEstate.id && (
        <div>
          <FeaturedFormCarousel estateId={activeEstate.id} />
        </div>
      )}

      <div style={{ paddingTop: "2rem" }}>
        <ContactAnAdvisor />
      </div>

      <AtticusDrawer
        variant="temporary"
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        contents={drawerContents}
      />
    </>
  ) : (
    <></>
  );
};

export default FormsAndFilesScreen;
